<template>
  <subjects @onUpdate="onUpdate" @onReprove="onReprove" :config="config" />
</template>

<script>
import AdminSubjects from "./AdminSubjects"

export default {
  name: 'AdminSubjectsApproved',
  components: { 'subjects': AdminSubjects },
  data: (vm) => {
    return {
      config: {
        title: 'Cadastros Aprovados',
        empty: 'Não existem cadastros aprovados neste momento.',
        navItems: [{ url: '/admin/subjects/to_approve', title: 'Cadastros em Análise', icon: 'dashboard' }],
        load_url: vm.$root.urls.admin_companies_cleared
      }
    }
  },
  methods: {
    onUpdate(companies, record) {
      if ((record.clearance_level * 1) == 0) {
        companies.splice(companies.findIndex(el => el.id === record.id), 1)
      }
    },
    onReprove(companies, record) {
      companies.splice(companies.findIndex(el => el.id === record.id), 1)
    }
  }
}

</script>




// WEBPACK FOOTER //
// src/AdminSubjectsApproved.vue